const ICON_MAP = {
  "fa-lightbulb-o":    "fa fa-lightbulb-o",
  "fa-flag":           "fa fa-flag",
  "fa-search":         "fa fa-search",
  "fa-check-square-o": "fa fa-check-square-o",
  "fa-truck":          "fa fa-truck",
  "fa-shopping-cart":  "fa fa-shopping-cart",
};

export const Services = ({ data }) => (
  <div id="services" className="text-center">
    <div className="container">
      <div className="section-title">
        <h2>What We Do</h2>
        <p>
          From product development and brand building to sourcing, quality
          assurance and distribution — we manage the full consumer product
          value chain.
        </p>
      </div>
      <div className="row">
        {data ? data.map((s, i) => (
          <div key={i} className="col-md-4 col-sm-6 service-box">
            <i className={`${ICON_MAP[s.icon] || "fa fa-star"} service-icon`} aria-hidden="true"></i>
            <div className="service-desc">
              <h3>{s.title}</h3>
              <p>{s.description}</p>
            </div>
          </div>
        )) : null}
      </div>
      <div className="row services-stats">
        {[
          { num: "30+",       label: "Product Variants" },
          { num: "2",         label: "Active Brands" },
          { num: "Pan-India", label: "Distribution" },
          { num: "Future",    label: "Multi-Category" },
        ].map((s, i) => (
          <div key={i} className="col-md-3 col-sm-6 stat-box">
            <div className="stat-num">{s.num}</div>
            <div className="stat-label">{s.label}</div>
          </div>
        ))}
      </div>
    </div>
  </div>
);
